module.exports = __webpack_public_path__ + "static/media/fork.a0017bb5.png";